import { Reveal } from "./Reveal";
import { SERVICES } from "../../data/site";

const IMG = {
  cooking: "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxjaGVmJTIwcHJlcGFyaW5nJTIwZnJlc2glMjBoZWFsdGh5JTIwbWVhbHxlbnwwfHx8fDE3ODY2OTk4NzB8MA&ixlib=rb-4.1.0&q=85",
  dog: "https://images.unsplash.com/photo-1530700131180-d43d9b8cc41f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3YWxraW5nJTIwZG9nJTIwc3VubnklMjBwYXJrfGVufDB8fHx8MTc4NjY5OTg3MHww&ixlib=rb-4.1.0&q=85",
  linen: "https://images.unsplash.com/photo-1596433904493-c7ae3d6d179f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxuZWF0bHklMjBmb2xkZWQlMjBsaW5lbiUyMHNoZWxmfGVufDB8fHx8MTc4NjY5OTg4Mnww&ixlib=rb-4.1.0&q=85",
};

const TextCard = ({ index, title, desc, dark = false, className = "" }) => (
  <div className={`group p-8 flex flex-col justify-between rounded-2xl border transition-colors duration-500 ${dark ? "bg-[#1A362D] border-[#1A362D]" : "bg-[#EAE6DF] border-[#D5D1C8] hover:bg-[#D1DEC9]"} ${className}`}>
    <span className={`text-sm font-medium ${dark ? "text-[#D1DEC9]" : "text-[#7B8A83]"}`}>/ {index}</span>
    <div className="mt-10">
      <h3 className={`font-serif text-3xl leading-tight ${dark ? "text-[#F9F8F6]" : "text-[#1A362D]"}`}>{title}</h3>
      <p className={`mt-3 leading-relaxed ${dark ? "text-[#D1DEC9]" : "text-[#4A5A53]"}`}>{desc}</p>
    </div>
  </div>
);

const ImageCard = ({ src, label, className = "" }) => (
  <div className={`relative rounded-2xl overflow-hidden border border-[#D5D1C8] group ${className}`}>
    <img src={src} alt={label} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms]" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#1A362D]/70 via-transparent to-transparent" />
    <span className="absolute bottom-6 left-6 font-serif text-2xl md:text-3xl text-[#F9F8F6] z-10">{label}</span>
  </div>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-5">What we do</p>
            <h2 className="font-serif font-light text-5xl md:text-6xl text-[#1A362D] tracking-tight leading-[1.05] max-w-2xl">
              More than cleaning.<br />A helping hand for the whole home.
            </h2>
          </div>
          <p className="text-[#4A5A53] max-w-sm">
            Tailored to each household — pick one service or hand over the entire running of your home.
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 auto-rows-[minmax(220px,auto)]">
        <Reveal className="md:col-span-5 flex"><TextCard index="01" {...SERVICES[0]} className="w-full" /></Reveal>
        <Reveal delay={0.05} className="md:col-span-7 flex"><ImageCard src={IMG.cooking} label={SERVICES[1].title} className="w-full min-h-[280px]" /></Reveal>

        <Reveal className="md:col-span-4 flex"><TextCard index="02" {...SERVICES[2]} className="w-full" /></Reveal>
        <Reveal delay={0.05} className="md:col-span-4 flex"><ImageCard src={IMG.linen} label={SERVICES[3].title} className="w-full min-h-[280px]" /></Reveal>
        <Reveal delay={0.1} className="md:col-span-4 flex"><TextCard index="03" {...SERVICES[4]} className="w-full" /></Reveal>

        <Reveal className="md:col-span-7 flex"><ImageCard src={IMG.dog} label={SERVICES[4].title} className="w-full min-h-[300px]" /></Reveal>
        <Reveal delay={0.05} className="md:col-span-5 flex"><TextCard index="04" {...SERVICES[5]} className="w-full" /></Reveal>

        <Reveal className="md:col-span-6 flex"><TextCard index="05" {...SERVICES[6]} dark className="w-full" /></Reveal>
        <Reveal delay={0.05} className="md:col-span-6 flex"><TextCard index="06" {...SERVICES[7]} className="w-full" /></Reveal>
      </div>
    </div>
  </section>
);
